import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignUserEntitlementsSlice = getBulkActionSlice(
    'assignUserEntitlementsResult',
);

export const selectAssignUserEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignUserEntitlementsResult.shown;

export const selectAssignUserEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignUserEntitlementsResult.uuid;

export const selectAssignUserEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignUserEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignUserEntitlementsSlice.actions;
